/**
 * InstagramUserInfo 骨架屏组件
 *
 * CLS 优化：为搜索结果提供布局稳定的骨架屏
 * 与 InstagramUserInfo 组件布局完全一致
 */
import { useTranslation } from 'next-i18next';
import Image from 'next/image';

export default function InstagramUserInfoSkeleton() {
  const { t } = useTranslation();

  return (
    <div className="flex justify-center items-center gap-4 mt-8 text-center max-md:flex-wrap max-md:justify-start max-md:items-start max-md:gap-2.5">
      {/* 头像 */}
      <div className="w-[3rem] h-[3rem] rounded-full overflow-hidden max-md:w-[3rem] max-md:h-[3rem] bg-gray-200 animate-pulse" />

      <div className="flex gap-4 max-md:flex-1 max-md:block max-md:space-y-1.5">
        <div className="flex items-center gap-3 max-md:gap-2">
          {/* 全名 - 使用与原组件相同的行高，内部用灰块占位 */}
          <span className="text-[1.5rem] leading-7 font-bold max-md:text-[1rem] max-md:leading-5 inline-flex items-center">
            <span className="inline-block w-12 h-[1.5rem] max-md:h-[1rem] bg-gray-200 rounded animate-pulse" />
          </span>
          <a className="flex items-center gap-1 text-[#6b7280]">
            {/* Instagram 图标 */}
            <div className="w-4 h-4 max-md:w-[1.375rem] max-md:h-[1.375rem]">
              <Image src="/images/follow/ins-mark.webp" alt="ins-mark" width={22} height={22} />
            </div>
            {/* 账号名 - 带 @ 前缀保持一致 */}
            <span className="leading-4 inline-flex items-center">
              @<span className="inline-block w-14 h-4 bg-gray-200 rounded animate-pulse ml-0.5" />
            </span>
          </a>
        </div>
        <div className="flex gap-4 items-center">
          <div className="flex gap-1">
            <span className="inline-block w-10 h-4 bg-gray-200 rounded animate-pulse" />
            <span className="text-gray-400">{t('Post')}</span>
          </div>
          <div className="flex gap-1">
            <span className="inline-block w-10 h-4 bg-gray-200 rounded animate-pulse" />
            <span className="text-gray-400">{t('Followers')}</span>
          </div>
          <div className="flex gap-1">
            <span className="inline-block w-10 h-4 bg-gray-200 rounded animate-pulse" />
            <span className="text-gray-400">{t('Following')}</span>
          </div>
        </div>
      </div>
    </div>
  );
}
